/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/
import { useQuery, gql } from '@apollo/client';
import { handleApolloError } from '@exo/frontend-common-apollo';

const GQL_GET_CART = gql`
  query CartById($id: ID) {
    me {
      id
      carts(cartId: $id) {
        id
        grandTotal {
          ...Currency
        }
        totalProductPrice {
          ...Currency
        }
        totalShippingCharge {
          ...Currency
        }
        totalAdjustment {
          ...Currency
        }
        totalShippingTax {
          ...Currency
        }
        totalSalesTax {
          ...Currency
        }
        adjustments {
          title
          amount {
            ...Currency
          }
        }
        taxedPrice{
          totalNet{
            centAmount
          }
          totalTax{
            centAmount
          }
        }
        shippingInfo {
          
          shipMode {
            id
            identifier
            shippingRate {
              currency
              value
            }
          }
          pickupInStore {
            id
            name
          }
          shippingAddress {
            id
            firstName
            lastName            
            country
            zip
            address1
            address2
            city
            province
            countryName
            company
            title
          }
        }
        lineItems {
          id
          quantity
          partnumber
          linePrice {
            ...Currency
          }
          unitPrice {
            ...Currency
          }
          sizeAttr {
            name
            value
          }
          product {
            id
            type
            thumbnail
            name
            partnumber
            price {
              list {
                ...Currency
              }
              offer {
                ...Currency
              }
            }
          }
          custom {
            fields{
              rotary_name
              rotary_email
              rotary_phone
              rotary_ref_number
              photo_ref_number
              photo_phone
              photo_email
              photo_name
            }
          }
        }
        customLineItems {
          id
          name {
            en
          }
          money {
            currencyCode
            centAmount
          }
          totalPrice {
            currencyCode
            centAmount
          }
          slug
          quantity
        }
        billingAddress {
          firstName
          lastName            
          country
          zip
          address1
          address2
          city
          province
          countryName
          company
          title
        }
      }
    }
  }

  fragment Currency on CmmMoney {
    value
    currency
  }
`;

export const useOrderDetails = (id) => {
  const { called, loading, data, error } = useQuery(GQL_GET_CART, {
    variables: {
     id
    }
  });

 

  handleApolloError(__filename, error);

  return { called, loading, data: data, error };
};
